import './OrderTypeSelector.scss';
import { useLocation, useNavigate } from 'react-router-dom';
import Button from 'devextreme-react/button';
import { Item, Toolbar } from 'devextreme-react/toolbar';
import { useAuth } from '../../../../contexts/auth';
import { useGetCompany } from '../../../../api/company';
import { BusinessFlow, ProductLine } from '../../../../types/enums';

export default function OrderTypeSelector() {

    let navigate = useNavigate();

    const { user } = useAuth();
    const dealer = useGetCompany(user?.companyId);

    let buttons = [
        { caption: "Retail Orders", url: "/dealer/orders/retail-orders" }
    ];

    if (dealer.data?.productLines.find(x => x.productLineID === ProductLine.SmallProjects)) {
        buttons.push({ caption: "Vanity Orders", url: "/dealer/orders/vanity-orders" });
    }

    if (dealer.data?.businessFlowID === BusinessFlow.Lowes) {
        buttons.push({ caption: "IME Orders", url: "/dealer/orders/ime-orders" });
    }

    buttons.push({ caption: "Work Orders", url: "/dealer/orders/work-orders" });

    const location = useLocation();
    const currentPath = (location.pathname === '/dealer/orders') ? '/dealer/orders/retail-orders' : location.pathname;

    return (
        <Toolbar className="button-toolbar order-type-selector">
            {
                buttons.map(x =>
                    <Item location={'before'} key={x.url}>
                        <Button
                            text={x.caption}
                            onClick={() => navigate(x.url)}
                            className={(currentPath.includes(x.url) ? "selected" : "")}
                        >
                        </Button>
                    </Item>)
            }
        </Toolbar>
    )
}

